import * as styles from "./styles.module.scss";

interface IProps {
  type: "fill" | "outlined";
  name: string;
  rounded?: boolean;
  color?: string;
  class?: string;
  bold?: boolean;
  fontSize?: any;
}

const IconComponent = (props: IProps) => {
  let iconClassList = props.type === "fill" ? "mat-symbol-round-fill" : "mat-symbol-round";
  iconClassList = props.bold ? iconClassList + " mat-symbol-round-bold" : iconClassList;

  return (
    <span className={`${styles.fontIcon} ${props.class ? styles[props.class] : ""}`}>
      <span
        className={`${styles.iconContainer} ${iconClassList} ${props.rounded ? styles.rounded : ""}`}
        style={{
          color: props.color,
          fontSize: props.fontSize,
        }}
        data-content={props.name}
      />
    </span>
  );
};

export default IconComponent;
